import { render, staticRenderFns } from "./ButtonMenu.vue?vue&type=template&id=05b7f4f4&scoped=true&lang=pug&"
import script from "./ButtonMenu.vue?vue&type=script&lang=js&"
export * from "./ButtonMenu.vue?vue&type=script&lang=js&"
import style0 from "./ButtonMenu.vue?vue&type=style&index=0&id=05b7f4f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b7f4f4",
  null
  
)

export default component.exports